import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollApplicationsManager } from "./components/RollApplicationsManager";

export const RollApplicationsPage = () => {
	return (
		<>
			<HelmetDexteel title="Roll Applications" />
			<RollApplicationsManager />
		</>
	);
};
